module.exports = __webpack_public_path__ + "img/banner-index.e1158118.png";